/** @jsx jsx */
import React, { Fragment } from 'react'
import { jsx } from 'theme-ui'
import { Col, Row, EVEntry } from '../helpers/react'
import { useEntities, useEntity } from '../helpers/selectors'
import ConnectedGuideCard from '../read-more-module/connected-guide-card'
import ButtonWrapper from '../click-out-links/button-wrapper'

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const {
    entries = [],
    children,
    colsMobile = 1,
    colsTablet = 2,
    colsDesktop = 3,
    layout,
    options = {},
    moduleActionLink = {},
  } = props
  const rowStyles = options?.styles?.row || {}
  const colStyles = options?.styles?.col || {}

  const rowSx = { ...rowStyles }
  const colSx = {
    variant: 'modules.collectionGrid.col',
    // '> div': { height: '100%' },
    /**
     * FIXME: The collection should not be responsible for the
     * vertical height of its children This is likely to ensure that
     * columns have the same height but couples `RichTextBlocks` to
     * requiring a wrapping div
     */
    ...colStyles,
  }

  const childrenArray = entries
    ? entries.map((entity, i) => (
        <EVEntry {...entity} key={i} removeBottomSpacing={true} removeTopSpacing={true} />
      ))
    : children

  const moduleActionLinkEntity = useEntity(moduleActionLink)
  const entriesEntity = useEntities(entries)
  const entryType = entriesEntity[0].sys.contentTypeId
  const isEntryUrl = entryType === 'url'

  const body = (
    <Row cols={[colsMobile, colsTablet, colsDesktop]} direction='row' wrap sx={rowSx}>
      <For index='key' each='child' of={childrenArray}>
        <If condition={child.props}>
          <Col span={1} key={key} sx={colSx}>
            {/* eslint-disable react/jsx-no-undef */}
            {isEntryUrl ? (
              <ConnectedGuideCard
                {...{
                  ...child.props,
                  entity: {
                    sys: {
                      id: child.props.sys.id,
                    },
                  },
                  useCardV2: true,
                }}
              />
            ) : (
              <child.type {...child.props} />
            )}
          </Col>
        </If>
      </For>
    </Row>
  )
  return layout === 'proposition' ? (
    <div className='proposition-body'>{body}</div>
  ) : (
    <Fragment>
      {body}
      {moduleActionLinkEntity.link && (
        <ButtonWrapper
          buttonVariant={moduleActionLinkEntity.buttonVariant}
          href={moduleActionLinkEntity.link}
          variant={moduleActionLinkEntity.variant}
          size={moduleActionLinkEntity.size}
          target={moduleActionLinkEntity.openInNewTab ? '_blank' : null}
        >
          {moduleActionLinkEntity.text}
        </ButtonWrapper>
      )}
    </Fragment>
  )
}
